// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[component]{display:flex;flex-wrap:wrap}form>.schema-row>div[component]{padding:7px 13;width:100%;margin:7px 0;background-color:#fff}form>.schema-row>div[component] h6{margin-left:-8px}form>.schema-row{width:100%}", ""]);
// Exports
module.exports = exports;
